import React from 'react';
import { Tooltip, styled, TooltipProps } from "@mui/material";

interface ConditionalTooltipProps {
  text: string;
  maxLength?: number;
  children: React.ReactElement;
  isMobile: boolean;
}
interface StyledTooltipProps extends TooltipProps {
  className?: string;
}
const CustomTooltip = styled(({ className, ...props }: StyledTooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  "& .MuiTooltip-tooltip": {
    backgroundColor: "#1a1a1a",
    color: "white",
    fontSize: "14px",
    borderRadius: "8px",
    padding: "12px",
    maxWidth: "300px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    marginTop: "8px !important",
    marginBottom: "8px !important",
  },
  "& .MuiTooltip-arrow": {
    color: "#1a1a1a",
    "&::before": {
      backgroundColor: "#1a1a1a",
    },
  },
  '& .MuiTooltip-popper[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
    top: "0 !important",
  },
});

export const ConditionalTooltip: React.FC<ConditionalTooltipProps> = ({
  text,
  maxLength = 20,
  children,
  isMobile
}) => {
  if (text.length <= maxLength || text === "All Countries" || text === "All Cities") {
    return children;
  }

  return (
    <CustomTooltip
      title={text}
      placement="bottom-start"
      arrow
      disableInteractive={!isMobile}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
    >
      {children}
    </CustomTooltip>
  );
};
